import React, { useEffect, useState } from "react";
import {
    Alert,
    Badge,
    Button,
    Col,
    DatePicker,
    Input,
    List,
    Popover,
    Row,
    Space,
    Table,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import {  getUrlGraph, getUrlKfeedHits, setSnFilterUrl } from "../../store/urlfilter";
import PreloaderNew from "../UI/PreloaderNew/PreloaderNew";
import styles from "./UrlFilterNew.module.css";
import dayjs from 'dayjs';
import { CloseOutlined, SearchOutlined, EyeOutlined, CalendarOutlined } from "@ant-design/icons";
import {
    getCheckErrors,
} from "../../store/documentation/selectors";
import GraphKfeed from "./GraphKfeed";
import UrlItemModal from "./UrlItemModal";
import { getOrgFallbacksInfo, getUrlGrapData, getUrlKfeedHitsData, getUrlLoaders, getUrlSnDropdown, getUrlSnFilter } from "../../store/urlfilter/selectors";
import { IconWarning } from "../../icons";
import { getRandomId } from "./utils";

function UrlKfeed() {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);

    const errors = useSelector(getCheckErrors);
    const isLoader = useSelector(getUrlLoaders);
    const graphData = useSelector(getUrlGrapData)
    const kfeedHitsData = useSelector(getUrlKfeedHitsData);
    const [currentPage, setCurrentPage] = useState(1);
    const snFilterStore = useSelector(getUrlSnFilter);
    const [snFilter, setSnFilter] = useState(null)

    const asetsDropDown = useSelector(getUrlSnDropdown);
    const [openDate, setOpenDate] = useState(false);
    const [dateFrequentlyFilter, setDateFrequentlyFilter] = useState(null);
    const [url, SetUrl] = useState(null);
    const fallbacksData = useSelector(getOrgFallbacksInfo);
    const [modalOpen, setModalOpen] = useState(false);
	const [ordering, setOrdering] = useState({
		popularity: null,
		first_seen: null,
		url: null,
		kfeed_hits: null,
	});

        //фильтры
        const [dateAfterFilter, setDateAfterFilter] = useState(null);
        const [dateBeforeFilter, setDateBeforeFilter] = useState(null);
        const [viewDataFilter, setViewDataFilter] = useState(null);

    const fetchDataHits=()=> {
        let filters = false;
        if (snFilter || dateAfterFilter || dateBeforeFilter) 
        filters={
            serial_nr: snFilter,
            date_after: dateAfterFilter?.split(' ')[0].split('.').reverse().join('-'),
            date_before: dateBeforeFilter?.split(' ')[0].split('.').reverse().join('-'),
            ordering: getOrderBy()
        }
        dispatch(getUrlKfeedHits({filters, page: currentPage}));
    }
    const fetchDataGraph=()=> {
        let filters = false;
        if (snFilter)
        filters={
            serial_nr: snFilter,
            
        }
        dispatch(getUrlGraph({filters}));
    }

    useEffect(()=> {
if(snFilterStore) {
    setSnFilter(snFilterStore); dispatch(setSnFilterUrl(null));
}
    }, [snFilterStore])

    const handleOpenChangeDate = () => setOpenDate(!openDate);

    useEffect(() => {
  
        const timerRefresh = setTimeout(fetchDataGraph, 500);
		return () => {

			clearTimeout(timerRefresh)
		}
    }, [snFilter]);

    useEffect(() => {
        
        const timerRefresh = setTimeout(fetchDataHits, 500);
		return () => {

			clearTimeout(timerRefresh)
		}
    }, [snFilter, dateAfterFilter, dateBeforeFilter, currentPage, ordering]);
    const formatLongUrl=(url, arr)=> {
        if (url.length>60) {
          let str = url.slice(0,59);
          arr.push(str);
     
          formatLongUrl(url.slice(60),  arr)
        } else  {arr.push(url);}
      return arr

    }
    const dateParse = (dateStr) => {
        if (dateStr){
        const dateParts = dateStr.split(" ");
        const date = dateParts[0].split(".").reverse().join("-");
        const time = dateParts[1];
        const timeZone = dateParts[3].slice(1, 2);
        let sign = '+';
        if (dateParts[3].includes('-')) {
            sign = '-';
        }
        if (timeZone >= 10) {
            const isoDateString = `${date}T${time}:00${sign}${timeZone}:00`;
            return isoDateString;
        }
        else {
            const isoDateString = `${date}T${time}:00${sign}0${timeZone}:00`;
            return isoDateString;
        }} else return null

    }
    const handleColorDates = (date) => {
            if (date){ const today = new Date();
            const datefirstSeen=new Date(dateParse(date))
       
            const diffInDays = Math.floor((today - datefirstSeen) / (1000 * 60 * 60 * 24));
            if (Math.abs(diffInDays) < 30) {
                
                return <Badge count={'<30 дн'} showZero color='red' />
            } else if (Math.abs(diffInDays) >= 30 && Math.abs(diffInDays) < 180) {
                return <Badge count={'<6 мес'} showZero color='orange' />
               
            } else { return <Badge count={'>6 мес'} showZero color='yellow' />
                
            }} else return 'Нет данных'
  
    };

    const columns = [
        createColumn("URL", "url", 3,false, (text, row)=> {return formatLongUrl(text, []).map((item, index)=> <span key={item + row.uuid + index}>{item}<br/></span>)},false, () => {
            return 0;
        },ordering.url ),
        createColumn("Кол-во запросов", "kfeed_hits", 1, false, false, false, () => {
            return 0;
        },ordering.kfeed_hits),

        createColumn("Популярность", "popularity", 1, false, false, false, () => {
            return 0;
        },ordering.popularity), 
        createColumn("First seen", "first_seen", 1, false, (text)=> handleColorDates(text), false, () => {
            return 0;
        },ordering.first_seen),

        createColumn("Детали", "kfeed_hits", 1, 'center', (text, row)=> <EyeOutlined  onClick={()=> {SetUrl({mask: row['mask'], item: row}); setOpenModal(true)}} style={{fontSize: '20px', color: 'rgb(128, 144, 184)'}}/>),
    ];
    const handleChangeDateAfter = (e) => {
     
        if (e?.$d) {
            setDateAfterFilter(e?.$d.toLocaleString("ru-RU").replace(",", ""));
            if (dateBeforeFilter) {
                setViewDataFilter(
                    e?.$d.toLocaleString("ru-RU").replace(",", "") +
                        "-" +
                        dateBeforeFilter
                );
            } else
                setViewDataFilter(
                    e?.$d.toLocaleString("ru-RU").replace(",", "") + " - "
                );
        } else setDateAfterFilter(null);
    };
    const handleChangeDateBefore = (e) => {
      
        if (e?.$d) {
            setDateBeforeFilter(e?.$d.toLocaleString("ru-RU").replace(",", ""));
            if (dateAfterFilter) {
                setViewDataFilter(
                    dateAfterFilter +
                        " - " +
                        e?.$d.toLocaleString("ru-RU").replace(",", "")
                );
            } else
                setViewDataFilter(
                    " - " + e?.$d.toLocaleString("ru-RU").replace(",", "")
                );
        } else setDateBeforeFilter(null);
    };
    const calculateYesterday=()=> {
        let today = new Date();
                today.setDate(today.getDate()-1); 
                return today
    }
    const calculateMonth=()=> {
        let date = new Date();
                date.setDate(date.getDate()-30); 
                return date
    }
     const frequency = {
        'today': {
            numberDate: (new Date()).setHours(0, 0, 0, 0),
            title: 'Сегодня'
        },

        'yesterday': {
            numberDate: (calculateYesterday()),
            title: 'Вчера'
        },

        '30d': {
            numberDate: (new Date()).getTime() - 2592000000,
            title: 'За последние 30 дней'
        },
        // '1y': {
        //     numberDate: (new Date()).getTime() - 31536000000,
        //     title: 'За последний год'
        // },
        '1y': {
            numberDate: (new Date()).getTime() - 31536000000,
            title: 'За последний год'
        },
    };

    const dateFormat = "YYYY-MM-DD";
    
    const resetDateFilterBefore = (value) => {
        const date =
            value?.split(" ")[0].split(".").reverse().join("-") +
            " " +
            value?.split(" ")[1];
        return dayjs(date, dateFormat);
    };
 const resetDateFilterAfter = (value) => {
    
        const date =
            value?.split(" ")[0]?.split(".")?.reverse().join("-") +
            " " +
            value?.split(" ")[1];
        return dayjs(date, dateFormat);
    };
    const frequentlyUsedFilters = [];

    Object.keys(frequency).forEach((key, i)=>{
        frequentlyUsedFilters.push(
            <Button style={{background: 'transparent', border: 'none'}}key={i} disabled={(key==='1y')&&!fallbacksData?.has_fallbacks_enabled? true: false}onClick={() => {setCurrentPage(1);handleSetDateFilters(key)}}>
                {frequency[key].title}
            </Button>
        )
    })
useEffect(()=> {
    if (fallbacksData) {

         handleSetDateFilters('today');
    }
},[fallbacksData])

    const handleSetDateFilters = (value) => {
        if (frequency[value]) {
            setDateFrequentlyFilter(value);
            setViewDataFilter(frequency[value].title);
            const actualDate = new Date(frequency[value].numberDate);
            setDateAfterFilter(actualDate.toLocaleString('ru-RU').replace(',', ''));
        }

        setOpenDate(false);
    }
      const content = (

        <List
            size="small"
            header={false}
            footer={<div>
                <hr/>
                <Space direction="vertical" >
                    <span>Начало</span>
                    <DatePicker
                         renderExtraFooter={() => null} 
                        footer={null}
                     
                        format="DD-MM-YYYY"
                        onChange={(e)=> {setCurrentPage(1);handleChangeDateAfter(e)}}
                        showNow={false}
                        showToday={false}
                        placeholder="Выберите дату начала"
                        disabledDate={d =>{
                            
                        return  !fallbacksData?.has_fallbacks_enabled?    !d || d.isBefore(calculateMonth()) || d.isAfter(new Date())
                         :   !d || d.isBefore("2024-01-01") || d.isAfter(new Date()) }}
                         //   return d &&  d.isAfter(calculateYesterday()) && d.isBefore("2024-01-01")}}
                        value={
                            dateAfterFilter
                                ? resetDateFilterAfter(dateAfterFilter)
                                : null
                        }
                    />
                    <span>Окончание</span>
                    <DatePicker
                        showNow={false}
                        showToday={false}
                        renderExtraFooter={() => null} 
                        format="DD-MM-YYYY"
                        disabledDate={d =>{
                            
                            return  !fallbacksData?.has_fallbacks_enabled?    !d || d.isBefore(calculateMonth()) || d.isAfter(new Date())
                             :   !d || d.isBefore("2024-01-01") || d.isAfter(new Date()) }}
                        onChange={(e)=> {setCurrentPage(1);handleChangeDateBefore(e)}}
                        placeholder="Выберите дату окончания"
                        value={
                            dateBeforeFilter
                                ? resetDateFilterBefore(dateBeforeFilter)
                                : null
                        }
                    />
                </Space>
            </div>}
            className={styles.list}
            dataSource={frequentlyUsedFilters}
            renderItem={(item) => <List.Item
                className={styles.listItem}
                style={{
                    cursor: "pointer",
                    border: "none"
                }}
            >
                {item}
            </List.Item>}
        />
    );

    const handleSort = (field) =>{

        let tempOrdering = {
            popularity: null,
            url: null,
            kfeed_hits: null,
            first_seen: null,
        }
  
        switch (ordering[field])
        {
            case "ascend":
                tempOrdering[field] = "descend";
                break;
            case "descend":
                tempOrdering[field] = null;
                break;
            default:
                tempOrdering[field] = "ascend";
        }
  
        setOrdering(tempOrdering)
    }
    const getOrderBy = () => {

		let orderBy = '';

		Object.keys(ordering).forEach(key=>{
			if (ordering[key] === 'ascend') orderBy = key
			if (ordering[key] === 'descend') orderBy = '-'+key
		})


		return orderBy
	}
    return (
        <Space
            direction="vertical"
            size={20}
            style={{ width: "100%", position: "relative" }}
        >
            {
                openModal && (
                    <UrlItemModal
                        open={openModal}
                        mask={url.mask}
                        item={url.item}
                        close={() => setOpenModal(false)}
                    />
                )
                // item={modalItem}
            }
            {isLoader && <PreloaderNew />}
            {fallbacksData?.has_fallbacks_enabled===false&&fallbacksData?.has_kfeed_hits===true &&

<Alert message={'Для использования полного функционала KFEED PLUGIN, необходимо приобрести лицензию. Обратитесь к своему менеджеру PARUS.'} type="warning" 
    showIcon icon={<IconWarning />} closable>
   
</Alert>
} <Row>
    <Button type='primary' onClick={()=> setModalOpen(true)}>График за 30 дн.</Button>
</Row>
            <Row justify="start" gutter={8}>

            <Col >
                 <Input
                    prefix={<SearchOutlined style={{ color: "#C1C2C9" }} />}
                    placeholder="Поиск по SN"
                    onChange={(evt) => {
                        setCurrentPage(1);
                        setSnFilter(evt.target.value);
                    }}
                    value={snFilter}
                    suffix={
                        <CloseOutlined
                            onClick={() => {
                                setCurrentPage(1);
                                setSnFilter("");
                            }}
                        />
                    }
                    style={
                        snFilter
                            ? {
                                  color: "red",
                                  width: "356px",
                                  height: 32,
                                  padding: "8px 12px",
                              }
                            : {
                                  color: "black",
                                  width: "356px",
                                  height: 32,
                                  padding: "8px 12px",
                              }
                    }
                /></Col>
                <Space.Compact
                    style={{ alignSelf: "flex-end" }}
                    title="Выберите интервал"
                >
                    <Popover
                        placement="bottomLeft"
                        open={openDate}
                        onOpenChange={handleOpenChangeDate}
                        title={false}
                        content={content}
                        trigger="click"
                    >
                        <Button
                            className={styles.dashboardInput}
                            style={{
                                display: "flex",
                                alignItems: "center"
                            }}
                        >
                            <CalendarOutlined
                                style={{
                                    padding: "5px 0",
                                    color: "#6679A9"
                                }}
                            />
                            <span style={{padding: "0 5px", fontSize: 12}}>
                                {viewDataFilter}
                            </span>
                        </Button>
                    </Popover>
                </Space.Compact>

                 
                 {(snFilter|| dateAfterFilter || dateBeforeFilter) && <Button style={{marginLeft: '5px'}}type="default" onClick={()=> {setCurrentPage(1); setSnFilter(null); handleSetDateFilters('today')}}>Сбросить</Button>}
                    </Row>
            <Row gutter={[8, 8]} justify="center" >
                <Col span={24} md={24} style={{background: 'white', borderRadius:  '8px', padding: 0}}>
                    
                    <Table
                        columns={columns}
                        locale={{
                            triggerDesc: "сортировать по убыванию",
                            triggerAsc: "сортировать по возрастанию",
                            cancelSort: "сбросить",
                        }}
                        onHeaderRow={() => {
                            return {
                              onClick: (e) => {
                                
                                  switch (e.target.innerText) {
                                      case "ПОПУЛЯРНОСТЬ":
                                          handleSort('popularity');
                                          break;
                                      case "URL":
                                          handleSort('url');
                                          break;
                                      case "КОЛ-ВО ЗАПРОСОВ":
                                          handleSort('kfeed_hits');
                                          break;
                                      case "FIRST SEEN":
                                          handleSort('first_seen');
                                          break;
                                    //   case "ОС":
                                    //       handleSort('os_name');
                                    //       break;
                                    //   case "ВЕРСИЯ ОС":
                                    //       handleSort('os_ver');
                                    //       break;
                                    //   default:
                                    //       console.log(e.target.innerText)
                                  }
                              },
                            };
                          }}
                        size="small"
                        scroll={{
                            y: 400,
                          }}
                        rowKey={(row) => getRandomId(row.uuid)}
                        pagination={{
                            current: currentPage,
                            position: "bottomRight",
                            defaultPageSize: 100,
                            showSizeChanger: false,
                            total: kfeedHitsData?.count,
                            onChange: (page) => setCurrentPage(page),
                        }}
                        style={{ overflowX: "auto", }}
                        className={styles.table}
                       dataSource={kfeedHitsData?.results || []}
                    />
                </Col>
               
                      {modalOpen &&   <GraphKfeed statsData={graphData} open={modalOpen} close={()=> setModalOpen(false)}/>}

            </Row>
        </Space>

    );
}

function createColumn(title, key, width, align, render, defaultSortOrder, sorter, sortOrder) {
    return { title, key, dataIndex: key, width, align, render, defaultSortOrder, sorter, sortOrder };
}
export default UrlKfeed;
